<div class="ml-0 mr-0 mt-4 pl-3" *ngIf="sectionInfo">
  <div class="row">
    <div class="col-6 d-flex align-items-center">
      <h5>Review and Concurrence</h5>
      <span class="waiting ml-2">
        <waiting-dots *ngIf="sectionLoading"></waiting-dots>
      </span>
      <status-chips [statuses]="statuses"></status-chips>
    </div>
    <div class="col-6 d-flex justify-content-end">
      <span *ngIf="showReloadButton" class="btn m-0">
        <button
          mat-stroked-button
          color="warn"
          (click)="refresh()"
          [disabled]="disableButtons"
        >
          <mat-icon color="warn">refresh</mat-icon> Reload BL Staff
        </button>
      </span>
      <span
        *ngIf="
          section?.showCompleteButton && absi?.status == formStatusEnum.Active
        "
        class="btn m-0"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="complete()"
          [disabled]="disableButtons"
        >
          Inspections Complete
        </button>
      </span>
      <span
        *ngIf="
          section?.showCloseButton &&
          absi?.status == formStatusEnum.ReviewAndConcurrence
        "
        class="btn m-0"
      >
        <button
          mat-flat-button
          color="accent"
          (click)="revert()"
          [disabled]="disableButtons"
        >
          Return to Inspections
        </button>
      </span>
    </div>
  </div>

  <absi-sectionX
    id="section"
    #section
    [section]="sectionInfo"
    [formId]="absi?.id"
    [sectionId]="sectionInfo.id"
    [absi]="absi"
    [message]="message"
    [collapse]="false"
    (setButtons)="setButtons($event)"
  ></absi-sectionX>
</div>
<div class="row">
  <div class="col-12 d-flex justify-content-end">
    <span *ngIf="showOlogButton" class="btn m-0">
      <button mat-stroked-button color="primary" (click)="editOlog()">
        Edit Olog Notification&nbsp;<mat-icon color="primary"
          >feedback</mat-icon
        >
      </button>
    </span>
  </div>

  <div class="col-12 close-col" *ngIf="!sectionLoading">
    <cl-close-action
      [currentChecklist]="absi"
      [disabled]="
        !(
          showCloseButton && absi?.status == formStatusEnum.ReviewAndConcurrence
        )
      "
      [roleCodes]="closeSignature?.roleCodes"
      [roleIds]="closeSignature?.roles"
      title="Close ABSI Checklist"
      [value]="closeSignature?.approved"
      [user]="closeSignature?.approvedBy"
      [date]="closeSignature?.approvedOn"
      [taskID]="closeSignature?.taskId"
      (closed)="close($event)"
    ></cl-close-action>
  </div>
</div>
